// Generated by CoffeeScript 2.7.0
var DomMaster;

import Base from './base.js';

import Selector from './selector.js';

import Manipulator from './manipulator.js';

import AttributeSet from './attribute_set.js';

export default DomMaster = (function() {
  class DomMaster extends Base {
    constructor(node) {
      super();
      this.withContainer = false;
      this.node = this.parseNode(node);
      this.manipulator = new Manipulator(this);
      this.selector = new Selector(this);
      this.attribute_set = new AttributeSet(this);
    }

    static init(node) {
      return new this(node);
    }

    static wrap(value) {
      if (value instanceof this) {
        return value;
      } else {
        return new this(value);
      }
    }

    static none() {
      return new this();
    }

    isPresent() {
      return !!this.node;
    }

    presence() {
      if (this.isPresent()) {
        return this;
      } else {
        return null;
      }
    }

    parseNode(node) {
      var container;
      if (node instanceof HTMLElement) {
        this.node = node;
      } else {
        container = document.createElement('div');
        container.innerHTML = node || '';
        this.node = container.childElementCount <= 1 ? container.firstChild : (this.withContainer = true, container);
      }
      return this.node;
    }

    childNodes() {
      if (!this.isPresent()) {
        return [];
      } else if (this.withContainer) {
        return this.node.childNodes;
      } else {
        return [this.node];
      }
    }

  };

  DomMaster.Selector = Selector;

  DomMaster.Manipulator = Manipulator;

  DomMaster.AttributeSet = AttributeSet;

  DomMaster.delegates(['find', 'findAll', 'closest'], {
    to: 'selector'
  });

  DomMaster.delegates(['data', 'removeData'], {
    to: 'attribute_set'
  });

  DomMaster.delegates(['add', 'remove', 'toggle', 'contains'], {
    to: 'node.classList',
    suffix: 'Class'
  });

  DomMaster.delegates(['prepend', 'append', 'replaceWith', 'html', 'remove', 'hide', 'show', 'toggle'], {
    to: 'manipulator'
  });

  DomMaster.delegatesToClass(['find', 'findAll', 'getScrollableContainer'], {
    to: 'Selector'
  });

  return DomMaster;

}).call(this);
